module.exports = __webpack_public_path__ + "static/img/Lighthouse.8969288.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lighthouse.jpg
// module id = pwsE
// module chunks = 1